import React from "react";
import { Route, Routes, createBrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { LoginPage, useAuth } from "../libs/auth";
import Shell from "../libs/shell";
import { logOut } from "../libs/auth/store/auth.slice";
import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks/app-store.hook";
import Dashboard from "../feature/dashboard";
import { NotFoundPage } from "../libs/core";
import UserManager from "../feature/users";
import BlogManager from "../feature/blogs";

import SubscribersManager from "../feature/newsletter";

import ProfilePage from "../feature/dashboard/profile_page";
import BlogDetailPage from "../feature/blogs/blog_details";
import TestimonialList from "../feature/testimonials";

import ContactUsManager from "../feature/ContactUs";
import NewsLetterManager from "../feature/newsletter/news_letter_manager";
import NewsletterDetailPage from "../feature/newsletter/newsletter_detail";

export const Routing = (): JSX.Element => {
    /* hooks */
    const { session } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

  
    const localSession = localStorage.getItem("session");
  
    useEffect(() => {
      if (!session || !localSession) {
        dispatch(logOut());
        navigate("/login");
      } else if (session && location.pathname === "/login") {
        navigate("/");
      }
    }, [session, location.pathname, navigate, dispatch, localSession]);
  
    return (
      <>
        {/* <ScrollRestoration /> */}
        <Routes>
          {session === null && <Route path="/login" element={<LoginPage />} />}
  
          {session !== null && (
            <Route path="/" element={<>{<Shell />}</>}>
              <Route index element={<Dashboard/>}/>
              <Route path="/users" element={<UserManager/>} />
              <Route path="/blogs" element={<BlogManager/>} />
              <Route path="/testimonials" element={<TestimonialList/>} />
              <Route path="/subscribers" element={<SubscribersManager/>} />
              <Route path="/profile" element={<ProfilePage/>} />
              <Route path="/blogs/:id" element={<BlogDetailPage/>} />
              <Route path="/messages" element={<ContactUsManager/>} />
              <Route path="/newsletters" element={<NewsLetterManager/>} />
              <Route path="/newsletters/:id" element={<NewsletterDetailPage/>} />
            </Route>
          )}

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </>
    );
  };